import { Spinner } from '@latitude/spinner';
import { cn } from '@latitude/token-utils';

import type { BackdropProps } from './types';

export { type BackdropProps };

/**
 * Backdrop component that provides a blurred background with optional loading spinner.
 */
export const Backdrop = ({
  classNames,
  loading,
  'data-testid': testID,
  rawProps = {},
}: BackdropProps) => {
  return (
    <div
      className={cn(
        [
          'flex',
          'flex-row',
          'items-center',
          'justify-center',
          'w-full',
          'h-full',
          'backdrop-blur',
          'gap-spacing-comp-action-small-gap',
        ],
        classNames?.backdrop,
      )}
      data-testid={testID}
      {...rawProps}
    >
      {loading && (
        <>
          <Spinner className={classNames?.spinner} />
          <span
            className={cn(classNames?.text, 'text-color-ref-text-link-primary')}
          >
            Loading...
          </span>
        </>
      )}
    </div>
  );
};
